<div class="m-20">
  <h3>Deze link is niet meer geldig</h3>
  <p>
    De vragenlijst die hoort bij de uitvraag is reeds ingevuld en ingediend. Daarmee is de link niet langer geldig. Bij
    vragen kan contact opgenomen worden met
    @if (clientTeamEmailAddress()) {
      het klant team via
      <a href="mailto:{{ clientTeamEmailAddress() }}">{{ clientTeamEmailAddress() }}</a
      >.
    } @else {
      het klant team.
    }
  </p>
</div>
<div class="mx-48"><hr class="border-2 border-gray-300" /></div>
<div class="m-20">
  <h3>This link is no longer available or not valid</h3>
  <p>
    The questionnaire associated with the request has already been completed and submitted. Therefore, the link is no
    longer valid. If you have any questions, please contact
    @if (clientTeamEmailAddress()) {
      the customer service team at
      <a href="mailto:{{ clientTeamEmailAddress() }}">{{ clientTeamEmailAddress() }}</a
      >.
    } @else {
      the customer service team.
    }
  </p>
</div>
